import type { AgentConfiguratorState } from '../types/agentConfigurator';
import type { GeneratePatchRequest } from '../types/nlt';
import type { OptimizationDatasetNamePayload } from './optimizationDatasetName';
import {
  prepareConnectorConfigForNltApi,
  type NltAdminConfigApiPayload,
} from './nltAdminConfigPayload';
import { formatOptimizationDatasetNameForApi, normalizeOptimizationDatasetNames } from './optimizationDatasetName';
import { buildNltPatchDialog, type NltPatchDialogSourceMessage } from './nltPatchDialog';

/** Config object for POST /nlt/patch (same nesting idea as config tuning: dataset_name on config). */
export function buildNltPatchConfigPayload(
  connectorConfig: AgentConfiguratorState,
  dataset_name?: OptimizationDatasetNamePayload
): Record<string, unknown> {
  const config = prepareConnectorConfigForNltApi(connectorConfig);
  if (dataset_name) {
    config.dataset_name = dataset_name;
  }
  return config;
}

export function buildNltGeneratePatchRequest(params: {
  connectorConfig: AgentConfiguratorState;
  nltAdmin: NltAdminConfigApiPayload;
  priorMessages: NltPatchDialogSourceMessage[];
  latestHuman: string;
  /** Dataset labels from picker (falls back applied in NLTSidebar). */
  datasetNames?: string[];
}): GeneratePatchRequest {
  const datasetNames = normalizeOptimizationDatasetNames(params.datasetNames);
  const dataset_name = formatOptimizationDatasetNameForApi(datasetNames);
  return {
    config: buildNltPatchConfigPayload(params.connectorConfig, dataset_name),
    nlt_config: params.nltAdmin.nlt_config,
    ...(params.nltAdmin.nlt_config_id ? { nlt_config_id: params.nltAdmin.nlt_config_id } : {}),
    ...(datasetNames.length > 0 ? { dataset_name: datasetNames } : {}),
    dialog: buildNltPatchDialog(params.priorMessages, params.latestHuman),
    rag_enabled: false,
    lang: 'ru',
  };
}
